import { categories } from "@/mocks/anime";

const tintClasses = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-700",
  "bg-primary-100/70 text-primary-700",
  "bg-secondary-100 text-secondary-700",
  "bg-accent-100/70 text-accent-700",
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
];

export default function Categories() {
  return (
    <section id="category" className="section-pad bg-background-100/60">
      <div className="container-site">
        <div className="max-w-xl">
          <span className="text-xs font-medium uppercase tracking-widest text-accent-600">Category</span>
          <h2 className="mt-1 font-heading text-3xl md:text-4xl">动漫分类 · 一键直达</h2>
          <p className="mt-2 text-sm text-foreground-600">
            热血、恋爱、奇幻、科幻……涵盖全类型，每个分类都支持高清全集连播，轻松找到想追的那一部。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {categories.map((cat, i) => (
            <a
              key={cat.name}
              href="#update"
              className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 card-shadow"
            >
              <span className={`grid h-14 w-14 shrink-0 items-center justify-center rounded-2xl text-2xl transition-transform duration-300 group-hover:scale-110 ${tintClasses[i % tintClasses.length]}`}>
                <i className={cat.icon} />
              </span>
              <span>
                <span className="block font-heading text-lg text-foreground-950">{cat.name}</span>
                <span className="mt-0.5 block text-xs text-foreground-500">{cat.count} 部高清片源</span>
              </span>
              <i className="ri-arrow-right-s-line ml-auto text-xl text-foreground-300 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-primary-500" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}